import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"label":"Api Bancária","placeholder":"Selecione a API Bancária","items":_vm.items,"item-text":"name","item-value":"id","return-object":"","rules":_vm.rules,"loading":_vm.loading,"readonly":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }